/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Currentpayment1Inputs */

const en__field_currentpayment1 = /** @type {(inputs: _Field_Currentpayment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const de__field_currentpayment1 = /** @type {(inputs: _Field_Currentpayment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {_Field_Currentpayment1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_currentpayment1 = /** @type {((inputs?: _Field_Currentpayment1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Currentpayment1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_currentpayment1(inputs)
	return de__field_currentpayment1(inputs)
});
export { _field_currentpayment1 as "_field_currentPayment" }